<template>
  <!-- MENU CONTAINER SECTION BACKGROUND -->
  <div class="menu_container_section_background">
    <v-overlay :value="isLoading"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
    <!-- MENU CONTAINER SECTION BACKGROUND -->
    <div class="menu_container_section_background">
      <div class="col-md-12 menu_container_section_container">
        <div v-for="(menu, index) in menusUsuario" :key="index" class="menu_container_section_"
          @click="handleClick(menu)">
          <div v-if="menu.novo == 1" class="novo-badge-item-menu">Novo</div>
          <figure class="menu_container_section_img">
            <img :src="menu.icon" />
          </figure>
          <div class="menu_container_section_text_container">
            <span class="menu_container_section_text_title">{{ menu.descricao }}</span>
          </div>
        </div>
      </div>
    </div>


    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogEstatistica" persistent max-width="490">
          <v-card>
            <v-card-title class="text-h5" style="background-color:#006699;color:white;">
              Selecção de dados Estatísticos
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="12"></v-col>
                <v-col md="12"></v-col>
                <v-col md="12">
                  <v-row>
                    <v-col md="12">
                      <v-select outlined :items="Listaranoslectivo" v-model="anolectivoSelected" item-value="descricao"
                        item-text="descricao" label="Selecione o Ano lectivo" return-object></v-select>
                    </v-col>
                    <v-col md="12">
                      <v-select v-model="tipoestatisticaSelected" outlined label="Selecione o relatório"
                        :items="tipoestatistica" item-text="descricao" item-value="id" return-object></v-select>
                    </v-col>
                    <v-col md="12">
                      <v-select v-model="tipoimpressaoSelected" outlined label="Selecione o tipo de impressão"
                        :items="tiposimpressao" item-text="descricao" item-value="id" return-object></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="darken-1" text @click="tipoestatisticaSelected = null; dialogEstatistica = false">
                Fechar
              </v-btn>
              <v-btn color="green darken-1" text
                :disabled="tipoestatisticaSelected === null || anolectivoSelected === null || tipoimpressaoSelected === null"
                @click="selectRelatorioEstatistico()">
                Continuar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- ********************************************************************************************************* -->
    <confirmadosMatriculados v-if="$store.state.showDialogGuia.estatistica" />
  </div>
  <!-- FIM MENU CONTAINER SECTION BACKGROUND -->
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
import Swal from "sweetalert2";
export default {
  components: {
    confirmadosMatriculados: () => import('../fin-escola/componentes/estatistica/estatisticaConfirmadosMatriculados.vue')
  },
  data: () => ({
    menusAll: [],
    menusUsuario: [],
    isLoading: false,
    dialogEstatistica: false,
    Listaranoslectivo: [],
    anolectivoSelected: null,
    tipoPautaSelected: null,
    tipoimpressaoSelected: null,
    tiposimpressao:
      [
        // { descricao: 'Word (Docx)', id: 1, sufixo: '.docx' },
        { descricao: 'PDF', id: 2, sufixo: '.pdf' }
      ],
    tipoestatistica:
      [
        { descricao: 'Mapa actualizado de venda de emolumentos', id: 1 }
        // { descricao: 'Planificação e estatística', id: 2 }
      ],
    tipoestatisticaSelected: null
  }),

  computed: {
    nivelUsuario() {
      return ls.get('nivel_user')
    }
  },


  created() {
    this.carregarAnosLectivo()
    this.carregarMenus();
  },

  methods: {

    async carregarMenus() {
      this.isLoading = true;
      if (this.nivelUsuario) {
        try {
          const rotasSaved = JSON.parse(ls.get('itemMenuRelatorio'))
          if (!rotasSaved) {
            this.menusAll = await axios.get('/carregarMenus/3').then((res) => res.data);
            this.menusUsuario = this.menusAll.filter(objeto => {
              const niveis = objeto.niveis.split(',')
              return niveis.includes(`${this.nivelUsuario}`)
            })
            ls.set('itemMenuRelatorio', JSON.stringify(this.menusUsuario))
          } else {
            this.menusUsuario = rotasSaved
          }
        } catch (error) {
          Swal.fire('Erro', 'Ocorreu um erro durante o carregamento dos menus da página!', 'error');
        } finally {
          this.isLoading = false;
        }
      } else {
        Swal.fire('Erro', 'Nivél do usuário não encontrado!', 'error');
      }
    },

    handleClick(menu) {
      if (menu.isRota == 0) {
        this.$router.push(menu.url)
      } else {
        eval(menu.funcao);
      }
    },


    async carregarAnosLectivo() {
      try {
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
      }
    },
    selectRelatorioEstatistico() {
      // @ts-ignore
      switch (this.tipoestatisticaSelected.id) {
        case 1:
          this.carregarConfirmadosMatriculados()
          break
        default:
          Swal.fire('Informação', 'Tipo de relatório inválido', 'warning')
          break
      }
    },
    carregarConfirmadosMatriculados() {
      this.dialogEstatistica = false
      this.titulo = 'A estatística dos alunos confirmados e matriculados'
      this.$store.state.isloading = true
      this.$store.state.anolectivoSelecionado = this.anolectivoSelected
      this.$store.state.tipoimpressao = this.tipoimpressaoSelected
      this.$store.state.showDialogGuia.estatistica = true
      this.tipoimpressaoSelected = null
      this.anolectivoSelected = null
      this.tipoestatisticaSelected = null
    }
  }
}
</script>